import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { TextBox } from '../TextBox'
import { Colors, TextAligning, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxMaxLine2Footnote4Center extends ITextBoxProps {}

export const TextBoxMaxLine2Footnote4Center = ({
  title,
  color = Colors.TEXT_ICON_PRIMARY,
  font = TextBoxTypes.Footnote4,
  alignment = TextAligning.Center,
  maxLines = 2,
  ...rest
}: ITextBoxMaxLine2Footnote4Center): JSX.Element => (
  <TextBox
    title={title}
    color={color}
    font={font}
    alignment={alignment}
    maxLines={maxLines}
    {...rest}
  />
)
